/**
 * Casa Chic Motion — parallax hero + scroll reveal
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) {
    /* In theme editor: skip animations, but make all reveal elements visible */
    function showRevealInEditor() {
      document.querySelectorAll('.cc-reveal').forEach(function (el) {
        el.classList.add('cc-visible');
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showRevealInEditor);
    } else {
      showRevealInEditor();
    }
    return;
  }

  var mql = window.matchMedia('(min-width: 990px)');

  /* ================================================================
     PARALLAX HERO
     ================================================================ */

  var heroWrapper = null;
  var heroImg = null;
  var io = null;
  var ticking = false;
  var heroVisible = false;
  var pendingFrame = null;
  var isActive = false;

  function updateParallax() {
    if (heroVisible && heroWrapper) {
      var rect = heroWrapper.getBoundingClientRect();
      var offset = Math.max(-24, Math.min(24, -rect.top * 0.08));
      heroImg.style.transform = 'scale(1.1) translate3d(0, ' + offset + 'px, 0)';
    }
    ticking = false;
    pendingFrame = null;
  }

  function scheduleFrame() {
    if (!ticking) {
      pendingFrame = window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  function onScroll() { scheduleFrame(); }

  function startParallax() {
    if (isActive) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!mql.matches) return;

    heroWrapper = document.querySelector('[id$="__hero"]');
    if (!heroWrapper) return;

    heroImg = heroWrapper.querySelector('.banner__media img');
    if (!heroImg) return;

    heroWrapper.classList.add('cc-parallax-active');

    io = new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      if (heroVisible) {
        scheduleFrame();
      } else if (heroImg) {
        heroImg.style.transform = 'scale(1.1)';
      }
    }, { threshold: 0 });
    io.observe(heroWrapper);

    window.addEventListener('scroll', onScroll, { passive: true });
    isActive = true;
    scheduleFrame();
  }

  function stopParallax() {
    if (io) { io.disconnect(); io = null; }
    window.removeEventListener('scroll', onScroll);
    if (pendingFrame !== null) { window.cancelAnimationFrame(pendingFrame); pendingFrame = null; }
    ticking = false;
    heroVisible = false;
    isActive = false;
    if (heroImg) heroImg.style.transform = '';
    if (heroWrapper) heroWrapper.classList.remove('cc-parallax-active');
    heroWrapper = null;
    heroImg = null;
  }

  mql.addEventListener('change', function (e) {
    if (e.matches) { startParallax(); } else { stopParallax(); }
  });

  /* ================================================================
     SCROLL REVEAL
     ================================================================ */

  function initScrollReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cc-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.cc-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });

    /* Staggered reveal automatico sulle card homepage */
    var gridObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var grid = entry.target;
        grid.querySelectorAll('.grid__item').forEach(function (item, i) {
          item.style.transitionDelay = (i * 80) + 'ms';
          item.classList.add('cc-reveal', 'cc-visible');
        });
        gridObserver.unobserve(grid);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

    var homeSections = [
      '[id$="__featured-collection"]',
      '[id$="__featured-collection-casa"]'
    ];
    homeSections.forEach(function (sel) {
      var grid = document.querySelector(sel + ' .product-grid');
      if (grid) gridObserver.observe(grid);
    });
  }

  /* ================================================================
     SECTION REVEAL — staggered entrance per sezione
     ================================================================ */

  function initSectionReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var TEXT_TARGETS = [
      '.image-with-text__heading',
      '.image-with-text__text',
      '.image-with-text__buttons',
      '.rich-text__heading',
      '.rich-text__text',
      '.multicolumn__title',
      '.multicolumn-card',
      '.collection-list__item',
    ];

    var IMG_TARGETS = ['.image-with-text__media img'];

    // Sezioni con sistemi di animazione propri — skip
    var SKIP = [
      '__hero', '__brand-marquee-top', '__trust-bar',
      '__featured-collection', '__featured-collection-casa', '__occasions',
    ];

    function shouldSkip(id) {
      return SKIP.some(function (s) { return (id || '').endsWith(s); });
    }

    var seen = new Set();

    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (shouldSkip(section.id)) return;

      var textItems = [];
      TEXT_TARGETS.forEach(function (sel) {
        section.querySelectorAll(sel).forEach(function (el) {
          if (!seen.has(el) && !el.classList.contains('cc-reveal')) {
            seen.add(el);
            textItems.push(el);
          }
        });
      });

      var imgItems = [];
      IMG_TARGETS.forEach(function (sel) {
        section.querySelectorAll(sel).forEach(function (el) {
          if (!seen.has(el) && !el.classList.contains('cc-reveal')) {
            seen.add(el);
            imgItems.push(el);
          }
        });
      });

      if (!textItems.length && !imgItems.length) return;

      // Imposta classi iniziali — elementi sotto il fold restano invisibili
      textItems.forEach(function (el) { el.classList.add('cc-reveal'); });
      imgItems.forEach(function (el) { el.classList.add('cc-reveal', 'cc-reveal--scale'); });

      var obs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        textItems.forEach(function (el, i) {
          setTimeout(function () { el.classList.add('cc-visible'); }, i * 100);
        });
        imgItems.forEach(function (el, i) {
          setTimeout(function () { el.classList.add('cc-visible'); }, i * 120 + 80);
        });
        obs.disconnect();
      }, { threshold: 0.04, rootMargin: '0px 0px -60px 0px' });

      obs.observe(section);
    });
  }

  /* ================================================================
     INIT
     ================================================================ */

  function init() {
    startParallax();
    initScrollReveal();
    initSectionReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
